import { useState, MouseEvent } from 'react';

import styles from './add-perk-input.module.scss';

type Props = {
    onAdd: (text: string) => boolean;
};

const AddPerkInput = ({ onAdd }: Props) => {
    const [text, setText] = useState('');
    const [alreadyExists, setAlreadyExists] = useState(false);

    const handleButtonClick = (ev: MouseEvent) => {
        ev.preventDefault();
        const added = onAdd(text.trim());
        if (!added) {
            return setAlreadyExists(true);
        }
        setAlreadyExists(false);
        setText('');
    };

    return (
        <>
            <div className={styles.newPerkInput}>
                <input
                    value={text}
                    onChange={(ev) => setText(ev.target.value)}
                    placeholder="Escribe el beneficio aquí"
                    type="text"
                />
                <button onClick={handleButtonClick}>Añadir</button>
            </div>
            {alreadyExists && (
                <p className={styles.error}>El beneficio ya existe</p>
            )}
        </>
    );
};

export { AddPerkInput };
